import { useEffect, useState } from 'react';
/** The user's `prefers-reduced-motion: reduce` setting, kept live. False
 * where matchMedia is unavailable (jsdom/happy-dom without the test stub).
 * CSS animations are already gated in the shared theme; this is for media
 * the component itself would start, such as the gallery's intro-video
 * overlay and the Home coach's listening loop. */
export function usePrefersReducedMotion() {
    const [reduced, setReduced] = useState(() => typeof window !== 'undefined' &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            return;
        }
        const query = window.matchMedia('(prefers-reduced-motion: reduce)');
        const sync = () => setReduced(query.matches);
        query.addEventListener('change', sync);
        return () => query.removeEventListener('change', sync);
    }, []);
    return reduced;
}
//# sourceMappingURL=use-prefers-reduced-motion.js.map